import { render, staticRenderFns } from "./PowerschoolImport.vue?vue&type=template&id=fe05b0ee"
import script from "./PowerschoolImport.vue?vue&type=script&lang=js"
export * from "./PowerschoolImport.vue?vue&type=script&lang=js"
import style0 from "./PowerschoolImport.vue?vue&type=style&index=0&id=fe05b0ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports